import { accessibilityTextStyles, baseStyles } from './circular-loading.styles';
import { cn } from '../../../utils/class-utils';

interface CircularLoadingProps {
  className?: string;
}

export function CircularLoading({ className }: CircularLoadingProps) {
  return (
    <div className={cn(baseStyles, className)} role="status">
      <span className={accessibilityTextStyles} />
    </div>
  );
}
